export default __webpack_public_path__ + "static/media/hamburger-menu-gray.86b69237.svg";